var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("DecisionProjectBuilder", {
        attrs: { viewModel: _vm.decisionProjectBuilder },
        on: { "create-decision": _vm.handleCreateDecisionProjectCommand },
      }),
      _vm._v(" "),
      _c("PortfolioProjectBuilder", {
        attrs: { viewModel: _vm.portfolioProjectBuilder },
        on: { "create-portfolio": _vm.handleCreatePortfolioProjectCommand },
      }),
      _vm._v(" "),
      _c("ProjectCloner", {
        attrs: { viewModel: _vm.projectCloner },
        on: { "clone-project": _vm.handleCloneProjectCommand },
      }),
      _vm._v(" "),
      _c("ProjectEditor", {
        attrs: { viewModel: _vm.projectEditor },
        on: {
          "update-project": _vm.handleUpdateProjectCommand,
          "delete-project": _vm.handleDeleteProjectCommand,
        },
      }),
      _vm._v(" "),
      _c("ProjectTemplateLinksManager", {
        attrs: { viewModel: _vm.projectTemplateLinksManager },
        on: { "update-links": _vm.handleUpdateProjectTemplateLinksCommand },
      }),
      _vm._v(" "),
      _c("ProjectWorkspaceSwitcher", {
        attrs: { viewModel: _vm.projectWorkspaceSwitcher },
        on: { "move-project": _vm.handleSwitchProjectWorkspaceCommand },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "padding-top": "130px" } },
        [
          _c("WorkspaceNavigation", {
            attrs: {
              workspaceId: _vm.workspaceId,
              workspaceName: _vm.workspaceName,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "container-fluid" }, [
            !_vm.initialized
              ? _c("h3", [
                  _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                  _vm._v(" Loading... "),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.initialized
              ? _c("div", [
                  _c("div", { staticClass: "d-flex" }, [
                    _c("div", { staticClass: "pr-1 flex-grow-1" }, [
                      _c(
                        "h1",
                        {
                          staticStyle: {
                            "font-size": "2em",
                            "font-weight": "300",
                            color: "#33475b",
                            margin: "0",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.workspaceName) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pr-1" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          on: { click: _vm.showPortfolioBuilder },
                        },
                        [
                          _vm._v(
                            "\n                            Create Portfolio\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pr-1" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          on: { click: _vm.showDecisionBuilder },
                        },
                        [
                          _vm._v(
                            "\n                            Make Decision\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                  ]),
                  _vm._v(" "),
                  _c("hr", {
                    staticStyle: {
                      "border-color": "#bbb",
                      margin: "20px 0 60px",
                    },
                  }),
                  _vm._v(" "),
                  _vm.projects.length === 0
                    ? _c("div", [
                        _c("p", { staticClass: "lead" }, [
                          _vm._v("You don't have any projects yet."),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.projects.length > 0
                    ? _c(
                        "nav",
                        {
                          staticClass:
                            "navbar navbar-expand-lg navbar-light bg-light",
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "collapse navbar-collapse",
                              attrs: { id: "ProjectsTpl_NavigationBar" },
                            },
                            [
                              _c("ul", { staticClass: "navbar-nav" }, [
                                _c("li", { staticClass: "nav-item dropdown" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link dropdown-toggle",
                                      attrs: {
                                        href: "#",
                                        "data-toggle": "dropdown",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Order by " +
                                          _vm._s(_vm.orderBy) +
                                          "\n                                    "
                                      ),
                                      !_vm.orderByDescending
                                        ? _c("i", {
                                            staticClass: "fa fa-sort-alpha-asc",
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.orderByDescending
                                        ? _c("i", {
                                            staticClass:
                                              "fa fa-sort-alpha-desc",
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "dropdown-menu" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: { click: _vm.orderByName },
                                      },
                                      [_vm._v("Name")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: { click: _vm.orderByCreated },
                                      },
                                      [_vm._v("Date of creation")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item",
                                        on: { click: _vm.orderByLastActivity },
                                      },
                                      [_vm._v("Last activity")]
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "form",
                                {
                                  staticClass: "form-inline my-2 my-lg-0 ml-2",
                                  attrs: { role: "search" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "input-group input-group-sm",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.searchPhrase,
                                            expression: "searchPhrase",
                                          },
                                        ],
                                        staticClass:
                                          "form-control form-control-sm",
                                        attrs: {
                                          type: "search",
                                          placeholder: "Search",
                                        },
                                        domProps: { value: _vm.searchPhrase },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.searchPhrase =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm._m(2),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "padding-bottom": "50px",
                        "margin-top": "20px",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.projectsView, function (p) {
                          return _c(
                            "div",
                            {
                              key: p.ProjectId,
                              staticClass: "col-md-4 col-sm-6",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "tile bg-color-gray5",
                                  staticStyle: {
                                    "margin-bottom": "20px",
                                    padding: "8px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "dropdown float-right" },
                                    [
                                      _vm._m(3, true),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-menu dropdown-menu-right",
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "sanitizedHref",
                                                  rawName: "v-sanitizedHref",
                                                  value: `/#/project/${p.ProjectId}`,
                                                  expression:
                                                    "`/#/project/${p.ProjectId}`",
                                                },
                                              ],
                                              staticClass: "dropdown-item",
                                            },
                                            [_vm._v("Open")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showProjectEditor(
                                                    p
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Edit or delete")]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "dropdown-divider",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showProjectCloner(
                                                    p
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Clone")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showProjectTemplateLinksManager(
                                                    p
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Share as a template")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showProjectWorkspaceSwitcher(
                                                    p
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Move to a workspace")]
                                          ),
                                          _vm._v(" "),
                                          _c("div", {
                                            staticClass: "dropdown-divider",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.exportToJson(p)
                                                },
                                              },
                                            },
                                            [_vm._v("Export to JSON")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "h5",
                                    {
                                      staticClass:
                                        "text-ellipsis font-weight-light",
                                      staticStyle: { "margin-top": "7px" },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "sanitizedHref",
                                              rawName: "v-sanitizedHref",
                                              value: `/#/project/${p.ProjectId}`,
                                              expression:
                                                "`/#/project/${p.ProjectId}`",
                                            },
                                          ],
                                          staticClass: "text-dark",
                                        },
                                        [_vm._v(_vm._s(p.Name))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-ellipsis fg-color-gray1",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(p.Description) +
                                          "  \n                                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "pr-1" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-outline-secondary",
          attrs: {
            href: "https://www.transparentchoice.com/user-guide/getting-started",
            title: "User guide: Getting started",
            target: "_blank",
          },
        },
        [
          _c("i", {
            staticClass: "fa fa-info",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#ProjectsTpl_NavigationBar",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation",
        },
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      { staticClass: "text-dark", attrs: { "data-toggle": "dropdown" } },
      [_c("i", { staticClass: "fa fa-ellipsis-h" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }